import FEEDBACK_CONSTANTS from '@/constants/feedbackConstants';

export default {
  heading: 'Tak for din vurdering!',
  text: 'Er der noget, vi kan forbedre? Del din mening med os.',
  form: {
    fields: [
      {
        type: 'textarea',
        name: FEEDBACK_CONSTANTS.FEEDBACK_NAME,
        placeholder: 'Din mening...'
      }
    ],
    submit: {
      label: 'Send'
    }
  }
};